import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TenantFoundGuard implements CanActivate {
  auth = inject(AuthService);
  router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getTenantId()) {
      this.router.navigateByUrl('/login');
      return false;
    }
    return true;
  }
}
